module.exports = __webpack_public_path__ + "img/no-apport.d9447062.svg";